import React from 'react';
import { marketingEmailSignupId } from '@constants/marketing';
import TextLink from '@solar/common/Link/TextLink';
import withPromoLogic, { PromoLogicProps } from './withPromoLogic';

const promoConfig = {
  original: 'Unlock Savings',
  sale: 'Get $20 Off',
};

function CaptureEmailNavMenuItem({ marketingCampaign, handleClick }: PromoLogicProps) {
  const onClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    handleClick();
  };

  return (
    <div className="flex">
      <TextLink
        href="#"
        title={promoConfig[marketingCampaign]}
        className={`${marketingEmailSignupId} font-rp-basetica text-solar-text-ultramarine text-base hover:text-solar-text-ultramarine focus:text-solar-text-ultramarine py-spacing-sm desktop:py-0`}
        onClick={onClick}
      >
        {promoConfig[marketingCampaign]}
      </TextLink>
    </div>
  );
}

export default withPromoLogic(CaptureEmailNavMenuItem, 'CaptureEmailNavMenuItem');
